<template>
    <aside class="menu scrollable">
        <p class="menu-label">Acortador de URL</p>
        <ul class="menu-list">
            <li>
                <a @click="goTo('urlShortener')">Acortador</a>
            </li>
        </ul>
        <p class="menu-label">Actividades económicas</p>
        <ul class="menu-list">
            <li>
                <a @click="goTo('economicActivities')">Actividades</a>
            </li>
        </ul>
        <p class="menu-label">Catalogos</p>
        <ul class="menu-list">
            <li>
                <a @click="goTo('scianCatalog')">SCIAN</a>
            </li>
            <li>
                <a @click="goTo('bureauKeys')">Claves Observacion Buro</a>
            </li>
            <li>
                <a @click="goTo('idTypes')">Tipos de identificación</a>
            </li>
            <li>
                <a @click="goTo('idIssuers')">Autoridades de identificación</a>
            </li>
        </ul>
        <p class="menu-label">FIRA</p>
        <ul class="menu-list">
            <li>
                <a @click="goTo('CreditScore')">Indicadores para Puntaje Crediticio</a>
            </li>
            <li>
                <a @click="goTo('CreditScoreEvaluation')">Valores para Puntaje Crediticio</a>
            </li>
            <li>
                <a @click="goTo('LossSeverity')">Severidad de la Pérdida</a>
            </li>
            <li>
                <a @click="goTo('Collateral')">Garantías</a>
            </li>
            <li>
                <a @click="goTo('CreditRiskRating')">Grado de Riesgo</a>
            </li>
        </ul>
        <p class="menu-label">Regiones</p>
        <ul class="menu-list">
            <li>
                <a href="/regions#countries">Paises</a>
            </li>
            <li>
                <a href="/regions#states">Estados</a>
            </li>
            <li>
                <a href="/regions#cities">Ciudades</a>
            </li>
            <li>
                <a href="/regions#colonies">Colonias</a>
            </li>
        </ul>
        <p class="menu-label">SEPOMEX</p>
        <ul class="menu-list">
            <li>
                <a @click="goTo('SepomexPaises')">Paises</a>
            </li>
            <li>
                <a @click="goTo('SepomexEstados')">Estados</a>
            </li>
            <li>
                <a @click="goTo('SepomexMunicipios')">Municipios</a>
            </li>
            <li>
                <a @click="goTo('SepomexCiudades')">Ciudades</a>
            </li>
            <li>
                <a @click="goTo('SepomexColonias')">Colonias</a>
            </li>
            <li>
                <a @click="goTo('SepomexCodigosPostales')">Codigos postales</a>
            </li>
        </ul>
        <p class="menu-label">Indicadores</p>
        <ul class="menu-list">
            <li>
                <a @click="goTo('indicators')">Indicadores</a>
            </li>
        </ul>
        <p class="menu-label">Envio de SMS</p>
        <ul class="menu-list">
            <li>
                <a @click="goTo('SMSApi')">Enviar SMS</a>
            </li>
        </ul>
        <p class="menu-label">Inegi Claves Geoestadísticas</p>
        <ul class="menu-list">
            <li>
                <a @click="goTo('InegiStates')">Área Geoestadística Estatal (AGEE)</a>
            </li>
            <li>
                <a @click="goTo('InegiMunicipalities')">Área Geoestadística Municipal (AGEM)</a>
            </li>
            <li>
                <a @click="goTo('InegiLocations')">Área Geoestadística Localidades por Estado</a>
            </li>
            <li>
                <a @click="goTo('InegiGeostatisticsCode')">Área Geoestadística Localidad por Código</a>
            </li>
        </ul>
    </aside>
</template>

<script>
export default {
    name: 'MainNavigation',
    props: {
        msg: String
    },

    methods: {
        goTo (name) {
            let routeData = this.$router.resolve({ name })
            window.open(routeData.href, '_self')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .menu-label {
    color: #000000;
    font-weight: bolder;
  }
</style>
